import React from 'react';
import PropTypes from 'prop-types';

export default function SortItemButtonDropdown({
    value,
    label,
    onClick,
    closeDropdown,
}) {
    const handleClickFromDropDown = () => {
        if (onClick) {
            onClick(value);
        }
        closeDropdown();
    };

    return (
        <button
            className="sort-item-dropdown-button sort-item-root"
            data-sort-value={value}
            onClick={handleClickFromDropDown}
        >
            {label}
        </button>
    );
}

SortItemButtonDropdown.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    closeDropdown: PropTypes.func,
};

SortItemButtonDropdown.defaultProps = {
    label: '',
    closeDropdown: null,
};
